<template lang="pug">
  .kpi
    loading(v-if="isLoading")
    bar-chart(
      v-if="!isLoading"
      :isHorizontal="false"
      :series="series"
      :categories="categories"
      yAxisTitle="Solicitudes"
      :tooltipFormatter="tooltipFormatter"
      xAxisTitle="Jefes"
      title="Solicitudes de vacaciones pendientes"
      subtitle="Cantidad de Solicitudes de vacaciones pendientes por aprobar por jefe"
      :showLegend="false"
      :showXlabels="true"
    )
</template>

<script>
import { apiGet } from '../../util/general';
import BarChart from '../charts/c_chart_bar';

export default {
  name: 'solicitudes_v_pendiente_aprobar_jefe',
  components: {
    'bar-chart':BarChart
  },
  data () {
    return {
      // Datos para el gráfico de empleados por área
      categories: [],
      series: [
        {
          name: 'Cantidad de solicitudes pendientes',
          data: []
        }
      ],
      isLoading:true
    };
  },
  created () {
    this.fetch();
  },
  methods: {
    tooltipFormatter (val) {
      return `${val}`;
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, '/kpi/solicitudes-vacaciones-pendientes-aprobar-jefe', {}, function (data) {
        vm.categories = []
        vm.series[0].data = []
        for (let index = 0; index < data.lista.length; index++) {
          const element = data.lista[index];
          vm.categories.push(element.nombre)
          vm.series[0].data.push(element.cantidad)
        }
      }, function (error) {
        console.error('error', error)
      }, function () {
        vm.isLoading = false
      })
    }
  }
};
</script>

<style lang="stylus" scoped>
/* Puedes agregar estilos personalizados aquí si es necesario */
.kpi
  display flex
  flex-direction column
  gap 20px
  padding 20px
  box-sizing border-box
</style>



// WEBPACK FOOTER //
// c_kpi_solicitudes_v_pendiente_aprobar_jefe.vue?07e3e23d